<div class="modalClose">
  <img src="/assets/img/shared/close.svg" (click)="closeModal()" />
</div>

<ion-content>
  <ion-fab vertical="top" horizontal="end" slot="fixed">
    <ion-fab-button (click)="goZoom(0.1)" size="small" style="margin-top: 40px">
      <ion-icon name="add-outline"></ion-icon>
    </ion-fab-button>
    <ion-fab-button
      (click)="goZoom(-0.1)"
      size="small"
      style="margin-top: 10px"
    >
      <ion-icon name="remove-outline"></ion-icon>
    </ion-fab-button>
    <ion-fab-button (click)="download()" size="small" style="margin-top: 10px">
      <ion-icon name="cloud-download-outline"></ion-icon>
    </ion-fab-button>
  </ion-fab>
  <pdf-viewer
    [src]="plainUrl"
    [render-text]="true"
    [fit-to-page]="true"
    [zoom]="zoom"
  ></pdf-viewer>
  <!--<ion-fab vertical="bottom" horizontal="center" slot="fixed">
        <ion-fab-button (click)="closeModal()">
            <ion-icon name="close"></ion-icon>
        </ion-fab-button>
    </ion-fab>-->
</ion-content>
